interface IProps {
  size?: number;
  color?: string;
}

const DeliveryNotScheduledPillIcon = ({
  size = 14,
  color = "#6B7280",
}: IProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <rect
        x="2"
        y="3"
        width="10"
        height="9"
        rx="1.5"
        stroke={color}
        strokeWidth="1.25"
      />
      <path d="M2 5.5H12" stroke={color} strokeWidth="1.25" />
      <path
        d="M4.5 2V4M9.5 2V4"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
      />
    </svg>
  );
};

export { DeliveryNotScheduledPillIcon };
